import styled from '@emotion/styled';
import { LanguageIcon } from '@seedlang/icons';
import CustomSelect from 'components/custom_select';
import FormError from 'components/form_factory/form_error';
import FormLabel from 'components/form_factory/form_label';
import { isArray } from 'lodash';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

const Wrapper = styled.div`
  margin: ${props => props.margin};
  position: relative;
`;

@observer
class FormFlagSelect extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    store: PropTypes.object.isRequired,
    options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onChange: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    margin: PropTypes.string,
  };

  static defaultProps = {
    options: [],
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.props.form.registerComponent(this.props);
  }

  handleChange = value => {
    this.props.onChange(this.props.name, value);
  };

  getValue() {
    const value = this.props.form.getValue(this.props.name);
    if (!value && this.props.form?.store?.formCache) {
      const languageId = this.props.form.store.formCache.languageId;
      if (languageId === 'EN2') {
        return 'GBR';
      } else if (languageId === 'EN') {
        return 'USA';
      }
    }
    return value || '';
  }

  getError() {
    return this.props.store.getError(this.props.name);
  }

  @computed get selectOptions() {
    if (isArray(this.props.options)) {
      return this.props.options.map(id => {
        return {
          id: id,
          content: <LanguageIcon languageId={id} width='24px' />,
        };
      });
    }
    return [];
  }

  render() {
    return (
      <Wrapper margin={this.props.margin}>
        <FormLabel {...this.props} />
        <CustomSelect
          options={this.selectOptions}
          value={this.getValue()}
          onChange={this.handleChange}
          placeholder={`Select ${this.props.label}`}
          disabled={this.props.disabled}
          centerOptions
        />
        <FormError message={this.getError()} />
      </Wrapper>
    );
  }
}

export default FormFlagSelect;